import { get, post, put, fileDown } from "@/utils/request";

import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getIPList = data =>
  post(`${riskApi}/risk/ipBet/page`, data);

export const createIpManagement = data =>
  post(`${riskApi}/risk/ipManagement/create`, data);

export const getIpManagementList = data =>
  post(`${riskApi}/risk/ipManagement/find`, data);

export const releaseIpManagement = data =>
  post(`${riskApi}/risk/ipManagement/release`, data);

export const getExport = (data, fileName) =>
  fileDown(`${riskApi}/risk/ipManagement/exportExcel`, data, fileName);

export const getAlarmList = data =>
  post(`${riskApi}/risk/cashoutControl/alarm/page`, data);

export const getAlarmExport = (data, fileName) =>
  fileDown(`${riskApi}/risk/cashoutControl/alarm/export`, data, fileName);

export const getAlarmUpdate = data =>
  post(`${riskApi}/risk/cashoutControl/alarm/update`, data);

export const getFindMarketListBySport = data =>
  post(`${riskApi}/risk/riskOrder/findMarketListBySport`, data);

export const getFindPeriodsBySportId = data =>
  post(`${riskApi}/risk/riskOrder/findPeriodsBySportId`, data);

export const getFindSportList = data =>
  get(`${riskApi}/risk/riskOrder/findSportList`, data);
